import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  ValidationProvider,
  ValidationObserver,
  configure
} from "vee-validate";
import VueI18n from "vue-i18n";
import messages from "./lang";
import { VuePlausible } from "vue-plausible";

library.add(fas);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("validation-provider", ValidationProvider);
Vue.component("validation-observer", ValidationObserver);

Vue.use(VueI18n);
Vue.use(VuePlausible, {
  domain: process.env.VUE_APP_PLAUSIBLE_XPO
});
Vue.$plausible.enableAutoPageviews();

export const dateTimeFormats = {
  es: {
    hourShort: {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false
    },
    dayShort: {
      day: "numeric"
    },
    dayText: {
      weekday: "long"
    },
    monthText: {
      month: "long"
    },
    short: {
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    },
    long: {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZoneName: "short",
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
    }
  },
  en: {
    hourShort: {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false
    },
    dayShort: {
      day: "numeric"
    },
    dayText: {
      weekday: "long"
    },
    monthText: {
      month: "long"
    },
    short: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    },
    long: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZoneName: "short",
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
    }
  },
  it: {
    hourShort: {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false
    },
    dayShort: {
      day: "numeric"
    },
    dayText: {
      weekday: "long"
    },
    monthText: {
      month: "long"
    },
    short: {
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    },
    long: {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZoneName: "short",
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
    }
  },
  pt: {
    hourShort: {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false
    },
    dayShort: {
      day: "numeric"
    },
    dayText: {
      weekday: "long"
    },
    monthText: {
      month: "long"
    },
    short: {
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    },
    long: {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZoneName: "short",
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
    }
  },
  fr: {
    hourShort: {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false
    },
    dayShort: {
      day: "numeric"
    },
    dayText: {
      weekday: "long"
    },
    monthText: {
      month: "long"
    },
    short: {
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    },
    long: {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZoneName: "short",
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
    }
  }
};

const numberFormats = {
  "en-US": {
    currency: {
      style: "currency",
      currency: "USD"
    }
  },
  "en-GB": {
    currency: {
      style: "currency",
      currency: "GBP"
    }
  },
  es: {
    currency: {
      style: "currency",
      currency: "EUR"
    }
  }
};

export const i18n = new VueI18n({
  locale: navigator.language ? navigator.language.split("-")[0] : "es",
  fallbackLocale: "es",
  messages,
  dateTimeFormats,
  numberFormats
});

configure({
  classes: {
    valid: "is-valid",
    invalid: "is-invalid",
    dirty: ["is-dirty", "is-dirty"]
  }
});

Vue.config.productionTip = false;

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount("#app");
